import Vue from "vue";
import VueI18n from "vue-i18n";
import fr from "./locales/fr";
import en from "./locales/en";
import es from "./locales/es";

Vue.use(VueI18n);

const messages = {
  fr,
  en,
  es,
};

// Détection automatique de la langue du navigateur
function getDefaultLocale() {
  const savedLocale = localStorage.getItem("locale");
  if (savedLocale && messages[savedLocale]) {
    return savedLocale;
  }

  const browserLocale = navigator.language.split("-")[0];
  return messages[browserLocale] ? browserLocale : "fr";
}

const i18n = new VueI18n({
  locale: getDefaultLocale(),
  fallbackLocale: "fr",
  messages,
});

export default i18n;
